module.exports = __webpack_public_path__ + "img/forex-trading-1.5e4e7903.png";